import { Stack, Box, Typography, GTIWebCarousel } from "@gti-controls-v2/web-core";
import consumosStyles from "../../../common/styles/Consumos";
import { useMediaQueryCustom } from "../../../hooks/useMediaQueryCustom/useMediaQueryCustom";
import { ConsumoPorTipo } from "./ConsumoPorTipo";
import useTranslation from "../../../hooks/useTranslation";

const styles = consumosStyles;

export const ConsumosTabletFooter = (props) => {

    const { isMobile480, isTablet768, isTablet1024 } = useMediaQueryCustom();
    const { t } = useTranslation();

    return (
        <>
            <Box sx={styles.consumosFooterTablet} height={isMobile480 ? "69px" : isTablet768 ? "79px" : "89px"}>
                <Stack direction="row" alignItems="center" width="20%">
                    <Typography fontSize={isMobile480 ? "14px" : isTablet768 ? "16px" : "18px"} fontWeight="500">
                        {t("sistema.consumos.titulos.consumosPorTipo")}
                    </Typography>
                </Stack>

                <Stack direction="row" alignItems="right" width="80%">
                    <GTIWebCarousel
                        show={isMobile480 ? 2 : isTablet768 ? 3 : isTablet1024 ? 4 : 6}
                        slide={1}
                        interval={10000}
                        backButtonTooltip={t("sistema.consumos.carousel.anterior")}
                        nextButtonTooltip={t("sistema.consumos.carousel.siguiente")}
                        buttonsFontSize={40}
                        direction="rtl"
                        disabledButtonsColor="transparent"
                    >
                        {props.cortes.map(item => (
                            // Using item.CafeProdID as a key to ensure uniqueness
                            <ConsumoPorTipo key={item.CafeProdID} tipo={item.CafeProdNombre} cantidad={item.Conteo} />
                        ))}
                    </GTIWebCarousel>
                </Stack>
            </Box>
        </>
    )
}
